import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription, take } from 'rxjs';

import { LaunchScreenEnabledService } from 'src/app/shared/services/launch-screen/launch-screen.service';
import { LoadFlowOriginService } from 'src/app/shared/services/load-flow-origin/load-flow-origin.service';
import { Utils } from 'src/app/shared/utils/utils';
import { selectFrodoSettings } from 'src/app/stores/settings';

import { GuidedLoadingContext } from '../../interfaces/IGuidedLoadingContext';

declare global {
  interface Window {
    loadOrderCounter: number;
  }
}

@Component({
  selector: 'frodo-load-confirmation',
  templateUrl: './load-confirmation.component.html',
  styleUrls: ['./load-confirmation.component.scss'],
})
export class LoadConfirmationComponent implements OnInit, OnDestroy {
  private routeData: GuidedLoadingContext;

  title = '';
  image = '/assets/confirmation.svg';
  imageAlt = 'confirmation';
  logo = '/assets/logo.png';
  logoAlt = 'logo';
  confirmationTimeout: NodeJS.Timeout;
  subscription: Subscription = new Subscription();

  constructor(
    private store: Store,
    private utils: Utils,
    private activatedRoute: ActivatedRoute,
    private loadFlowOrigin: LoadFlowOriginService,
    private launchScreen: LaunchScreenEnabledService
  ) {}

  ngOnInit(): void {
    this.routeData = this.activatedRoute.snapshot.data as GuidedLoadingContext;
    this.title = this.routeData.translations.yourOrderIsLoaded;

    this.store
      .select(selectFrodoSettings)
      .pipe(take(1))
      .subscribe((frodoSettings) => {
        this.confirmationTimeout = setTimeout(() => {
          const resting = this.launchScreen.restingScreen(frodoSettings.launchScreen.enable);
          this.utils.thresholdRedirect(this.loadFlowOrigin.consumeExit(resting));
        }, frodoSettings.timeouts.confirmation);
      });
  }

  ngOnDestroy(): void {
    clearTimeout(this.confirmationTimeout);
  }
}
